import { computed } from '@vue/composition-api'
import router from '../../router'

const useRouter = () => {

    const route = computed(() => router.app.$route)

    return {
        route,
        router,
    }
}

export default useRouter